module.exports = __webpack_public_path__ + "images/marketing/cornerstone-background.jpg";